import MobileTableCell from "./MobileTableCell";

export default MobileTableCell;
